<template>
    <div>
        <div v-if="!declaracao">                
            <p>Você pode pagar o boleto do seu aluguel ou das despesas do seu condomínio com cartão de crédito, em até 12 vezes.</p>
            <p>Consulte, abaixo, a melhor opção de parcelamento.</p>
            <table border="0" cellspacing='0'>
                <thead>
                    <tr>
                        <th>Parcelas</th>
                        <th align="right">Valor (R$)</th>
                        <th align="right">Total (R$)</th>
                        <!--
                            <th></th>
                        -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="parcela in parcelas" :key="parcela.id" :class="{selected: installments == parcela.parcela}"  @click="installments = parcela.parcela">
                        <td>{{ parcela.parcela == 1 ? 'Rotativo' : parcela.parcela }}</td>
                        <td align="right">{{ parcela.valor | number_format }}</td>
                        <td align="right">{{ parcela.total | number_format }}</td>
                        <!--
                            <td align="right">                            
                                <input type="radio"  :checked="installments == parcela.parcela"  />
                            </td>
                        -->
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-if="!declaracao">
            <label>
                <!--
                    <input type="checkbox" :value="true" v-model="declaracao" /> 
                    Li e concordo com os <a href="https://www.vilarica.com.br/boletos/termos-e-condicoes" target="_blank">termos e condiçoes</a>.
                <a @click="showTermos=true">Leia os termos e condições</a>
                    -->
                    <b>Leia os termos e condições</b>
            </label>
        </p>

        <div v-if="!declaracao && showTermos || true" class="termos">
            <p>Esse serviço está sujeito a encargos administrativos de transação, e de juros e IOF desde o momento de pagamento do boleto e que são devidos à operadora de seu cartão de crédito. Antes da contratação, consulte o CET (Custo Efetivo Total).</p>
            <p>A Imobiliária {{ imobiliaria }} não se responsabiliza pelos encargos exigidos pela operadora de seu cartão de crédito. Ao aceitar o pagamento parcelado de seu boleto de aluguel ou condomínio através de seu cartão de crédito, você estará aceitando arcar com o pagamento dos encargos administrativos e financeiros que serão cobrados pela integradora e administradora do cartão de crédito, declarando também ter ciência que tais encargos não resultarão em qualquer benefício financeiro para locador, condomínio ou imobiliária, pois reverterão integralmente para as referidas empresas.</p>
            <p>Bandeiras aceitas para esta operação: Visa, Mastercard, HiperCard.</p>
            <p>Para efetivar a operação você deve se dirigir à sua unidade de atendimento.</p>
            <p>Salientamos que trata-se de uma simulação e que os valores, percentuais e opções listadas acima deverão ser confirmados e validados no ato da efetivação da transação em sua unidade de atendimento.</p>
            <!--
                <button class="btn-blue" @click.prevent.stop="showCreditCard">Aceito os termos e condições e quero parcelar</button>
            -->
            <center><button class="btn-blue default-button" @click.prevent.stop="fechar">FECHAR</button></center>
        </div>
        <!--
        <div v-if="declaracao && installments">
            
            <div >
                <p>
                    Pagar em {{ installments }}x de R${{ parcelas[installments-1].valor | number_format }},
                    totalizando R${{ parcelas[installments - 1].total | number_format }}.
                </p>
                <form @submit.prevent.stop="checkout">
                    <label>
                        Número do cartão 
                        <CreditCardInput type="text" placeholder="" v-model="credit_card_number" ></CreditCardInput>
                    </label>
                    <div class="flex-grid">
                        <label>
                            Código de segurança
                            <CVVInput type="text" placeholder="" v-model="payment_profile.card_cvv" ></CVVInput>
                        </label>
                        <label>
                            Validade 
                            <CardExpirationInput type="text" placeholder="MM/AA" v-model="payment_profile.card_expiration"></CardExpirationInput>
                        </label>

                    </div>
                    <label>
                        Bandeira do Cartão {{ payment_profile.payment_company_code }}
                        <select v-model="payment_profile.payment_company_code">
                            <option value="">Bandeira</option>
                            <option v-for="bandeira in bandeiras" :value="bandeira.code" :key="bandeira.id">{{ bandeira.name }}</option>
                        </select>
                    </label>
                    <label>
                        Nome completo do portador do cartão
                        <input type="text" placeholder="" v-model="payment_profile.holder_name">
                    </label>
                    <label>
                        CPF/CNPJ do portador do cartão
                        <CPFInput type="text" placeholder="CPF/CNPJ" v-model="payment_profile.registry_code"></CPFInput>
                    </label>
                    
                     
                    <ul>
                        <li>
                            <button class="btn-blue" v-if="!pagando" @click.prevent.stop="installments=0;declaracao=false;showTermos=false;">Cancelar</button>
                            <button class="btn-blue" v-else disabled="disabled">Cancelar</button>
                        </li>
                        <li>
                            <button class="btn-blue" type="submit" v-if="!pagando">Pagar</button>
                            <button class="btn-blue " type="submit" v-else disabled="disabled">Enviando...</button>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
        -->
    </div>
</template>
<script>
/*
import CPFInput from '../../components/Input/CPF';
import CardExpirationInput from '../../components/Input/CardExpiration';
import CVVInput from '../../components/Input/CVV';
import CreditCardInput from '../../components/Input/CreditCard';

*/

//import { PaymentMethods, Customers, Bills } from '../../api/vindi';
/*
const GetCardType = function(number)
{
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
        return "visa";

    // Mastercard 
    // Updated for Mastercard 2017 BINs expansion
     if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) 
        return "mastercard";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
        return "american_express";

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
        return "discover";

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null)
        return "diners";

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null)
        return "diners";

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null)
        return "jcb";

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null)
        return "visa";

    return "";
}
*/

export default {
    props: ['boleto', 'valor', 'tipo', 'codcliente', 'cpf_cnpj', 'nome_cliente'],
    components: {
       /*
        CPFInput,
        CardExpirationInput,
        CVVInput,
        CreditCardInput
        */
    },
    filters: {
        number_format(value) {
            return new Intl.NumberFormat('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value);
        }
    },
    data() {
        return {       
            pagando: false,
            installments: 0,
            declaracao: false,
            showTermos: false,
            payment_profile: {
                holder_name: '',
                registry_code: '',
                card_expiration: '',
                card_number: '',
                card_cvv: '',
                payment_method_code: 'credit_card',
                payment_company_code: ''              

            },
            payment_method: null,
            juros: [
                4.04,
                5.24,
                5.91,
                6.58,
                7.25,
                7.92,
                8.84,
                9.51,
                10.18,
                10.85,
                11.52,
                12.19
            ]

        }
    },
    methods: {
        showCreditCard() {
            if (0 == this.installments) {
                alert("Selecione a opção de parcelamento acima.");
                return;
            }
            this.showTermos=false;
            this.declaracao=true;            
        },
        fechar() {
            window.$.fancybox.close();
        }
        /*
        loadPaymentMethods() {
            return PaymentMethods.get()
                .then(payment_method => {                    
                    this.payment_method = payment_method;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        */
       /*
        async checkout() {
            this.pagando = true;
            const reference_code = this.boleto;
            const amount = this.valor_total;
            const product_code = this.product_code;
            const customer_code = this.codcliente;
            const customer_registry_code = this.cpf_cnpj;
            const customer_name = this.nome_cliente;
            const { holder_name:card_holder_name, registry_code:card_registry_code, card_expiration, card_number, card_cvv, payment_method_code, payment_company_code } = this.payment_profile;
            const installments = this.installments;

            if (card_number.replace(/\D+/igm, '').length < 15) {
                alert("Informe o número do cartão de crédito corretamente.");
                return;
            }
            if (card_cvv.replace(/\D+/igm, '').length < 3) {
                alert("Informe o código de segurança corretamente.");
                return;
            }
            if (card_expiration.replace(/\D+/igm, '').length < 4) {
                alert("Informe a validade do cartão corretamente.");
                return;
            }
            
            if ('' == payment_company_code) {
                alert("Selecione a bandeira do cartão.");
                return;
            }

            if ('' == card_holder_name) {
                alert("Informe o nome do portador do cartão.");
                return;
            }

            if (![11,14].includes(card_registry_code.replace(/\D+/igm,'').length)) {
                alert("Informe o CPF/CNPJ do portador do cartão."+card_registry_code.replace(/\D+/igm,'').length);
                return;
            }
            

         
            await Bills.checkout({ 
                customer_name,
                customer_registry_code,
                customer_code,
                payment_method_code,
                installments,
                reference_code,
                amount,
                card_holder_name,
                card_registry_code,
                card_expiration,
                card_number,
                card_cvv,
                payment_company_code,
                product_code 
            })
                .then(resp => {
                    if (!resp.success) {
                        throw new Error(resp.msg);
                    }
                    alert(resp.msg);
                    $.fancybox.close();
                })
                .catch(err => {
                    console.error(err);
                    alert(err.message);
                });

                
            this.pagando = false;


        }
        */
    },
    computed: {
        /*
        brands() {
            if (!this.payment_method) {
                return []
            }
            return this.payment_method.payment_companies;
        },
        */
        imobiliaria() {
            if (/^(www\.)vilarica\.com\.br$/.test(location.host)) {
                return 'Vila Rica';
            }
            return 'São Luiz'
        },
        /*
        credit_card_number: {
            get() {
                return this.payment_profile.card_number;
            },
            set(value) {
                this.payment_profile.card_number = value;
                let brand_code = GetCardType(value.replace(/\D+/igm,''));
                let brand = this.brands.find(({ code }) => code == brand_code);
                if (brand) {
                    this.payment_profile.payment_company_code = brand_code;
                } else {
                    this.payment_profile.payment_company_code = '';
                }
            }
        },
        */
        valor_total() {
            let parcelas = this.parcelas;
            let parcela = parcelas[this.installments - 1];
            if (!parcela) {
                return 0.0;
            }
            return parcela.total;
        },
        parcelas() {
            let juros = this.juros;
            console.log(this.valor);
            let valor = +this.valor;

            let parcelas = juros.map((taxa,i) => {
                let parcela = i+1;
                let total = valor / (1 - taxa/100);
                let valor_parcela = Math.ceil(100*total/parcela)/100;
                total = Math.round(valor_parcela * parcela * 100)/100;
                return {
                    id: `${i}.${valor_parcela}`,
                    parcela,
                    total,
                    valor: valor_parcela
                }
            });
            return parcelas;
        },
        /*
        bandeiras() {
            if (!this.payment_method) {
                return [];
            }
            if ('undefined' === typeof this.payment_method.payment_companies) {
                return [];
            }
            return this.payment_method.payment_companies;
        },
        */
        product_code() {
            return this.tipo === 'Condominio' ? 'parc_boleto_condomino' : 'parc_boleto_inquilino';
        }
    },
    created() {        
        
        //this.loadPaymentMethods();
        /*
        Customers.get({
            customer_name: this.nome_cliente,
            customer_registry_code: this.cpf_cnpj,
            customer_code: this.codcliente
        })
            .then(console.log)
            .catch(console.error);
            */
    }
}
</script>

<style lang="less" scoped>    
.termos {
    p {
        text-align: justify;
    }
}
.btn-blue {
                        cursor: pointer;
                    }
    p {
        text-align: left;
        margin: 1em 0em!important;
        color: #333!important;
        display: flex;     
        position: relative;   
        input {
            position: relative;
            top: 2px;
        }
        a {
            color: #0d437b;
            font-weight: bold;
            cursor: pointer;
        }
    }
    table {
        width: 100%;        
        thead {
            tr {
                th {
                    color: #f58220;
                    font-weight: bold;
                    padding: 0.5em;
                    background-color: #efefef;
                    border: 0;
                    
                }
            }
        }
        tbody {
            tr {
                &:hover {
                    cursor: pointer;
                    td {
                        background-color: #efefef;
                    }
                }
                td {
                    padding: 0.5em;
                    border-bottom: 1px dashed #ccc;
                    &[align=right] {
                        text-align: right!important;
                    }
                    
                }
                &.selected {
                    td {
                        color: #0d437b;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    form {
        label {
            display: block;
            text-align: left;
            padding: 0.5em 0;
            box-sizing: border-box;
            input, select {
                width: 100%;
                padding: 0.5em;

                box-sizing: border-box;
            }
        }
        ul {
            display: flex;
            justify-content: space-between;
            margin-top: 1em;
            li {
                button {
                    cursor: pointer;
                }
            }
        }

        .flex-grid {
            display: flex;
            justify-content: space-between;
            label {
                width: ~"calc(50% - 1em)";
            }
        }
    }
</style>